import { Chord, AddableNote } from './models/Chord';
import { Note } from './models/Note';
import { chord } from './chord';

export function chordNames(selectedNotes: Note[]) {
  const chords: Chord[] = [];

  for (let root = 0; root < 12; root++) {
    const c = chord(selectedNotes, root);
    if (c) chords.push(c);
  }

  return chords
    .sort((a, b) => chordComplexity(a) - chordComplexity(b))
    .map(chordName);
}

function chordName(chord: Chord) {
  const { extension, alterations, additions } = analyseAdditions(chord);
  return (
    chord.name +
    (extension ? ` ${extension}` : '') +
    (alterations.length ? ` ${alterations.join('')}` : '') +
    (chord.sus ? ` sus${chord.sus}` : '') +
    (additions.length ? additions.map(a => ` add${a}`).join('') : '') +
    (chord.omit.length ? ` (omit ${chord.omit.join(', ')})` : '')
  );
}

function analyseAdditions(chord: Chord) {
  let extension = null;
  let extensionGap = null;
  const alterations = [];
  const additions = [];

  const alterationNotes: AddableNote[] = [5, 7, 9, 11, 13];
  for (const note of alterationNotes) {
    if (chord.add[note] != null) {
      if (note === 7 || chord.add[note] === '') {
        extension = `${chord.add[7]}${note}`;
      } else {
        alterations.push(`${chord.add[note]}${note}`);
      }
    } else if (note !== 5) {
      extensionGap = note;
      break;
    }
  }

  const additionNotes: AddableNote[] = [9, 11, 13];
  for (const note of additionNotes) {
    if (extensionGap && note > extensionGap && chord.add[note] != null) {
      additions.push(
        `${chord.add[note]}${chord.add[7] != null ? note : note - 7}`
      );
    }
  }

  return { extension, alterations, additions };
}

function chordComplexity(chord: Chord) {
  const { alterations, additions } = analyseAdditions(chord);
  return (
    (chord.sus ? 1 : 0) +
    alterations.length +
    additions.length +
    chord.omit.length +
    (chord.omit.includes(1) ? 1 : 0)
  );
}
